(function () {
  const announcement = document.querySelector('.announcement-bar');
  if (!announcement) return;

  const root = document.documentElement;

  const updateHeight = () => {
    const height = announcement.offsetHeight;
    root.style.setProperty('--announcement-height', height + 'px');
  };

  // Run once
  updateHeight();

  // Recalculate on resize (debounced for performance)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeight, 150);
  });

  // Optional: observe dynamic changes (marquee, fonts, etc.)
  const observer = new ResizeObserver(updateHeight);
  observer.observe(announcement);
})();